import { z } from "zod";

export const existingFileIdsSchema = z.object({
	existingFileIds: z.array(z.uuid()).or(z.null()),
});

export type ExistingFileIdsSchema = z.infer<typeof existingFileIdsSchema>;
